$(function() {
  // slick options
  const slickOptions = {
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  // slick slider init
  $('.bank_slick').slick(slickOptions);

  // used DOM elements
  const els = {
    $nav: $('.nav'),
    $navList: $('.nav_list'),
    $navLink: $('.nav_list_link'),
    $navLogo: $('.nav_logo'),
    $navWrapper: $('.nav_wrapper'),
    $navToggleBtn: $('.nav_toggleBtn'),
    $linkTargets: ['#fp_feature', '#fp_provider', '#fp_paymethod', '#fp_contactus'],
    $bankSlick: $('.bank_slick'),
    $bankSlickAreaBtn: $('.bankArea_list_item .btn'),
    $coworkList: $('.cowok_list'),
  };

  // for higher viewport, let feature block animate immediately
  if($(window).width() >= 768 && $(window).width() <= 1024) {
    $('#fp_feature').addClass('fp_feature__ani');
  }

  // mobile navToggleBtn trigger
  els.$navToggleBtn.on('click', function() {
    els.$nav.toggleClass('nav__active');
  });

  // navigation trigger to scroll
  els.$navLogo.on('click', function() {
    hideNavList();
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });

  els.$navLink.on('click', function() {
    hideNavList();
    const hrefTarget = $(this).attr('href');
    $('html, body').animate({ scrollTop: $(hrefTarget).offset().top }, 'slow');
  });

  // bank area btn trigger
  els.$bankSlickAreaBtn.on('click', function(){
    const area = $(this).data('area');
    els.$bankSlickAreaBtn.removeClass('btn_rounded__active');
    $(this).addClass('btn_rounded__active');
    els.$bankSlick.addClass('bank_slick__hide');
    els.$bankSlick.slick('unslick');
    $(`.bank_list__${area}`).removeClass('bank_slick__hide').slick(slickOptions);
  });

  // scroll event for nav animation
  $(window).on('scroll', debounce(function() {
      if ($(this).scrollTop() > 160) {
        els.$navWrapper.addClass('nav_wrapper__active');
      } else {
        els.$navWrapper.removeClass('nav_wrapper__active');
      }

      const windowHeight = $(window).height();

      els.$linkTargets.forEach(id => {
        if ($(this).scrollTop() < 100) return els.$navLink.removeClass('nav_list_link__active');
        if ($(this).scrollTop() > $(id).offset().top - 50
          && $(this).scrollTop() < $(id).offset().top + 100) {
          els.$navLink.removeClass('nav_list_link__active');
          $(`[href="${id}"]`).addClass('nav_list_link__active');
        }
        if ($(this).scrollTop() > ($(id).offset().top - windowHeight/2 - windowHeight/3)) {
          $(id).addClass(`${id.split('#')[1]}__ani`);
        }
      });
      
      // cowork animation
      const coworkOffsetHeight = $('.cowork_wrapper .section_title').offset().top;
      if ($(this).scrollTop() > coworkOffsetHeight - windowHeight/2 - windowHeight/3) {
        els.$coworkList.addClass('cowok_list__ani');
      }
    }, 10)
  );

  function hideNavList() {
    els.$navLink.removeClass('nav_list_link__active');
    els.$nav.removeClass('nav__active');
  }
});

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
